import axios from '../http/axios';

const BASE_URL_SERVICO = '/softkit-temas/tema/'

export default {
  getTheme : (hash) => {
    return axios
      .get(`${BASE_URL_SERVICO}${hash}`)
      .then(res => { return res.data; });
  }
};
